// FUNCTIONALITY-115 — honest availability mapping. Unknown never becomes available.
import type { CatalogV2Product } from "./catalog-v2-types.js";

export type ProductAvailabilityState = "available" | "unavailable" | "unknown";

export interface ProductAvailability {
  state: ProductAvailabilityState;
  labelUa: string;
  canAdd: boolean;
}

export function resolveProductAvailability(product: CatalogV2Product): ProductAvailability {
  const raw = String(product.stockStatus ?? "").trim().toLowerCase();
  if (["in_stock", "available", "present", "low_stock", "on_stock"].includes(raw)) {
    return { state: "available", labelUa: "Є в наявності", canAdd: product.isSellable };
  }
  if (["out_of_stock", "unavailable", "not_available", "sold_out", "absent", "discontinued"].includes(raw)) {
    return { state: "unavailable", labelUa: "Немає в наявності", canAdd: false };
  }
  if (raw === "preorder") {
    return { state: "available", labelUa: "Під замовлення", canAdd: product.isSellable };
  }
  return { state: "unknown", labelUa: "Наявність уточнюється", canAdd: false };
}
